module.exports = __webpack_public_path__ + "static/img/nanjindongnandaxue.e4048da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/nanjindongnandaxue.png
// module id = XycJ
// module chunks = 36